import React from "react";

export default function About() {
  return (
    <div className="about-page flex-col space-b">
      <h1>Hello about page!</h1>
    </div>
  );
}
